import * as React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const LinkStyled = styled(NavLink)`
  text-decoration: none;

  &.active {
    color: ${Colors.Dark};
  }

  ${ct({
    Dark: css`
      color: ${Colors.White};
    `,
    Light: css`
      color: ${Colors.Darkest};
    `,
  })};
` as React.FC<NavLinkProps>;
